import { Link } from 'react-router-dom';
import { ArrowUpRight, Phone, Download as DownloadIcon } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { Reveal } from '@/components/Reveal';

export default function CTABand() {
  const { t, isRTL } = useLanguage();
  return (
    <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8" data-testid="cta-band">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-brand-blue to-brand-sky p-10 sm:p-14" data-testid="cta-band-card">
          <div className="pointer-events-none absolute inset-0 grid-bg-dark opacity-80" />
          <div className="pointer-events-none absolute -end-24 -top-24 h-72 w-72 rounded-full bg-white/15 blur-3xl" />
          <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-xl">
              <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">{t('ctaBand.title')}</h2>
              <p className="mt-3 text-base leading-relaxed text-sky-100">{t('ctaBand.sub')}</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link to={t('ctaBand.cta1Link')} data-testid="cta-band-primary" className="group inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-bold text-brand-blue transition-all duration-300 hover:shadow-[0_18px_40px_-14px_rgba(0,0,0,0.4)]">
                {t('ctaBand.cta1')}
                <ArrowUpRight className={`h-4 w-4 transition-transform group-hover:-translate-y-0.5 ${isRTL ? 'rotate-[-90deg]' : ''}`} />
              </Link>
              <a href={`tel:${t('settings.phone').replace(/\s/g, '')}`} data-testid="cta-band-call" className="inline-flex items-center gap-2 rounded-full border border-white/40 px-6 py-3.5 text-sm font-bold text-white transition-colors duration-300 hover:bg-white/10">
                <Phone className="h-4 w-4" /> <span dir="ltr">{t('settings.phone')}</span>
              </a>
              <Link to={t('ctaBand.cta3Link')} data-testid="cta-band-download" className="inline-flex items-center gap-2 rounded-full border border-white/40 px-6 py-3.5 text-sm font-bold text-white transition-colors duration-300 hover:bg-white/10">
                <DownloadIcon className="h-4 w-4" /> {t('ctaBand.cta3')}
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
